import FilterAttributeHotelMethodsByType from '@ve/components/filters/common/filterMethods/filterAttributeHotelMethods/FilterAttributeHotelMethodsByType';

export default new FilterAttributeHotelMethodsByType('NearCenterFilter');